import { type ContentFileDto, ContentType, MetaAdsAdFormat } from "shared";

/** Files to show in the ad preview for a given format. */
export function metaAdsPreviewFiles(
	files: ContentFileDto[] | undefined,
	adFormat: MetaAdsAdFormat,
	mediaFileIds: number[],
): ContentFileDto[] {
	const all = files ?? [];
	if (adFormat === MetaAdsAdFormat.CAROUSEL || mediaFileIds.length > 1) {
		return all.filter((f) => f.type === ContentType.IMAGE);
	}
	return all.slice(0, 1);
}

/** Whether the preview should use a swipeable carousel layout. */
export function metaAdsUseCarouselPreview(
	adFormat: MetaAdsAdFormat,
	mediaFileIds: number[],
	previewFiles: ContentFileDto[],
): boolean {
	if (adFormat === MetaAdsAdFormat.CAROUSEL) {
		return previewFiles.length >= 1;
	}
	return mediaFileIds.length > 1 || previewFiles.length > 1;
}
